module.exports = __webpack_public_path__ + "static/media/coming-soon-2.3063ad2f.png";